import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { delayWhen, filter, map, switchMap, withLatestFrom } from 'rxjs';

import { selectIsScanFlowAllowedIfDefined } from 'app/features/settings/state/settings/settings.selectors';
import { userSessionClosed } from 'app/state/user-session/user-session.actions';

import { sendCurrentScanFlowRegistrationData } from '../scan-flow-labor-registration/scan-flow-labor-registration.actions';
import { sendCurrentScanFlowContainerMeasurementData } from '../scan-flow-result-registration/scan-flow-result-registration.actions';
import { resetScanFlowRegistrationData } from '../scan-flow.actions';
import { selectScanFlowInitializationProgress } from '../scan-flow.selectors';
import { endWorkScanFlow } from './scan-flow-break.actions';

// noinspection JSUnusedGlobalSymbols
@Injectable()
export class ScanFlowBreakEffects {
    // -- Scan Flow Break Process --
    // End break scan flow on user session closed
    endWorkScanFlowOnUserSessionClosed$ = createEffect(() =>
        this.actions$.pipe(
            ofType(userSessionClosed),
            withLatestFrom(this.store.pipe(selectIsScanFlowAllowedIfDefined)),
            filter(([, isScanFlow]) => isScanFlow),
            delayWhen(() =>
                this.store.pipe(
                    select(selectScanFlowInitializationProgress),
                    filter(({ done }) => done),
                ),
            ),
            map(([{ timestamp }]) =>
                endWorkScanFlow({
                    endWorkTimestamp: timestamp,
                }),
            ),
        ),
    );

    // Submit end break scan flow registration data
    endWorkRollOut$ = createEffect(() =>
        this.actions$.pipe(
            ofType(endWorkScanFlow),
            switchMap(({ endWorkTimestamp }) => {
                sendCurrentScanFlowContainerMeasurementData({
                    registrationTimestamp: endWorkTimestamp,
                });
                return [
                    sendCurrentScanFlowRegistrationData({
                        registrationTimestamp: endWorkTimestamp,
                    }),
                    resetScanFlowRegistrationData(),
                ];
            }),
        ),
    );

    constructor(
        private actions$: Actions,
        private store: Store,
    ) {}
}
